import React from 'react';

const IconPlus = () => {
  return (
    <div style={{ pointerEvents: 'none' }}>
      <svg
        style={{ pointerEvents: 'none' }}
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M0 8H16" stroke="#222222" strokeWidth="2" />
        <path d="M8 0L8 16" stroke="#222222" strokeWidth="2" />
      </svg>
    </div>
  );
};

export default IconPlus;
